<section class="carousel-section new-releases"
  [ngClass]="{'new-releases': whichSlide === 'new', 'top-artist':whichSlide === 'artist', 'trending-now':whichSlide === 'trending', 'weekly-top':whichSlide === 'weekly'}">
  <div class="container overflow-visible">
    <div class="carousel-header">
      <div class="title-wrapper">
        <h3 class="carousel-title-audio">{{ title }}</h3>
        <!-- <a class="see-all" (click)="routeToParent('/audio/new-releases')">See All</a> -->
      </div>
      <div class="slider-control" *ngIf="listArray.length > 6">
        <a class="slider-nav prev" aria-label="Previous" routerLinkActive="active"
          [ngClass]="{'active': !activeNextButton || activeBothButton}" (click)="previousParent(sliderVar)">
          <svg viewBox="0 0 12 13" x="0px" y="0px" width="12px" height="13px">
            <g>
              <path
                d="M 0.9374 6.4719 L 6.4391 12.1207 L 7.7626 10.6967 L 4.288 7.4283 L 11.2852 7.4283 L 11.2852 5.5137 L 4.3799 5.5137 L 7.7626 2.2427 L 6.3538 0.8229 L 0.9374 6.4719 Z"
                fill="#000000" />
            </g>
          </svg>
        </a>
        <a class="slider-nav prev" aria-label="Next" routerLinkActive="active"
          [ngClass]="{'active': activeNextButton || activeBothButton}" (click)="nextParent(sliderVar)">
          <svg viewBox="0 0 12 13" x="0px" y="0px" width="12px" height="13px">
            <g>
              <path
                d="M 11.1176 6.4719 L 5.6151 12.1207 L 4.2903 10.6967 L 7.7672 7.4283 L 0.7708 7.4283 L 0.7708 5.5137 L 7.6754 5.5137 L 4.2903 2.2427 L 5.7024 0.8229 L 11.1176 6.4719 Z"
                fill="#000000" />
            </g>
          </svg>
        </a>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="slider-container"
      [ngClass]="{'new-releases-container': whichSlide === 'new', 'top-artist-container':whichSlide === 'artist', 'trending-now':whichSlide === 'trending', 'weekly-top':whichSlide === 'weekly'}">

      <div class="slider-outer">
        <ul *ngIf="listArray.length === 0">
          <li *ngFor="let data of skeletonArray;" class="slider-item">
            <div class="skeleton">
              <div class="skeleton-img element"></div>
              <div class=tweet-text>
                <div class="skeleton-line element"></div>
                <div class="skeleton-line element"></div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="slider-outer">


        <ul *ngIf="isSquare && listArray.length > 0" #slider (scroll)="onScroll($event)">
          <li *ngFor="let data of listArray; let i = index; let last = last" class="slider-item">
            <div class="single-card-square">
              <div class="card-square-thumb">
                <div class="image-cover">
                  <img *ngIf="(data.album_thumbnail | json) === '{}'"  src=" https://admin-vplayed-catrack-uat.contus.us/contus/base/images/no-preview.png" alt="Audio Thumbs" />
                  <img *ngIf="(data.album_thumbnail | json) !== '{}'"  [src]="data.album_thumbnail || data.audio_thumbnail" alt="Audio Thumb" />
                 
                </div>
                <div *ngIf="!isSong" class="overlay" (click)="routeToParent('/audio/albums/'+data.slug)"></div>
                <div  *ngIf="isSong" class="overlay" (click)="routeToParent('/audio/songs/'+data.slug)"></div>
                <a class="card-play-ic" (click)="playSongParent(whichSlide, i, data)">
                  <svg width="169" height="169" viewBox="0 0 169 169">
                    <g data-name="play icon" transform="translate(-240 -155)">
                      <circle data-name="Ellipse 2" cx="84.5" cy="84.5" r="84.5" transform="translate(240 155)"
                        fill="#fff" opacity="0.2" />
                      <path data-name="Subtraction 1"
                        d="M76.81,158.4a74.343,74.343,0,0,1-29.9-6.224,76.116,76.116,0,0,1-13.047-7.3A77.93,77.93,0,0,1,22.5,135.2,79.508,79.508,0,0,1,6.036,110.028a81.743,81.743,0,0,1,0-61.656A79.508,79.508,0,0,1,22.5,23.2a77.929,77.929,0,0,1,11.368-9.671,76.116,76.116,0,0,1,13.047-7.3,74.922,74.922,0,0,1,59.8,0,76.117,76.117,0,0,1,13.047,7.3A77.93,77.93,0,0,1,131.123,23.2a79.508,79.508,0,0,1,16.461,25.175,81.742,81.742,0,0,1,0,61.656A79.508,79.508,0,0,1,131.123,135.2a77.931,77.931,0,0,1-11.368,9.671,76.117,76.117,0,0,1-13.047,7.3A74.345,74.345,0,0,1,76.81,158.4ZM63.645,52.31a3.043,3.043,0,0,0-2.209.89,5.146,5.146,0,0,0-1.226,3.738l.2,45.534c.012,2.865,1.362,4.644,3.522,4.644a5.574,5.574,0,0,0,2.821-.888L104.6,83.693c1.682-1,2.61-2.337,2.614-3.761s-.919-2.767-2.6-3.78L66.47,53.213A5.545,5.545,0,0,0,63.645,52.31Z"
                        transform="translate(248 160)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-width="1" />
                    </g>
                  </svg>
                </a>
                <div class="action-holder">
                  <svg class="card-icon favourite_ic" width="17" height="14" viewBox="0 0 54.262 48.386"
                    (click)="favouriteSongParent(whichSlide,i)" *ngIf="data.is_favourite === 0">
                    <path
                      d="M137,463.776a3.121,3.121,0,0,1-2.059-.774c-2.152-1.881-4.226-3.649-6.056-5.209l-.009-.008c-5.366-4.573-10-8.522-13.224-12.411-3.6-4.349-5.283-8.472-5.283-12.977a16.649,16.649,0,0,1,4.225-11.37,14.324,14.324,0,0,1,10.654-4.637,13.4,13.4,0,0,1,8.368,2.889A17.1,17.1,0,0,1,137,422.812a17.08,17.08,0,0,1,3.384-3.533,13.393,13.393,0,0,1,8.367-2.889,14.326,14.326,0,0,1,10.654,4.637,16.653,16.653,0,0,1,4.225,11.37c0,4.5-1.678,8.627-5.281,12.976-3.225,3.891-7.857,7.84-13.224,12.411-1.833,1.562-3.911,3.333-6.066,5.219A3.13,3.13,0,0,1,137,463.776ZM125.248,419.51a11.236,11.236,0,0,0-8.36,3.632,13.539,13.539,0,0,0-3.4,9.255c0,3.788,1.408,7.176,4.564,10.985,3.051,3.682,7.59,7.55,12.846,12.028l.009.009c1.837,1.566,3.919,3.34,6.087,5.235,2.18-1.9,4.266-3.676,6.107-5.245,5.253-4.478,9.792-8.345,12.844-12.027,3.155-3.809,4.563-7.2,4.563-10.985a13.542,13.542,0,0,0-3.4-9.255,11.237,11.237,0,0,0-8.36-3.632,10.348,10.348,0,0,0-6.46,2.237,15.118,15.118,0,0,0-3.6,4.166,1.97,1.97,0,0,1-3.383,0,15.133,15.133,0,0,0-3.6-4.166A10.344,10.344,0,0,0,125.248,419.51Z"
                      transform="translate(-109.869 -415.89)" fill="#fff" stroke="#fff" stroke-width="1"></path>
                  </svg>
                  <svg version="1.1" viewBox="0 0 54.262 48.386" class="card-icon favourite_ic"
                    (click)="favouriteSongParent('trending',i)" *ngIf="data.is_favourite === 1">
                    <path fill="#FFFFFF" stroke="#FFFFFF"
                      d="M27.131,47.886c-0.758,0-1.489-0.275-2.06-0.774
                        c-2.151-1.881-4.226-3.649-6.056-5.209l-0.009-0.008c-5.366-4.573-10-8.522-13.224-12.411C2.183,25.134,0.5,21.012,0.5,16.507
                        C0.429,12.32,1.937,8.261,4.725,5.137C7.462,2.156,11.332,0.471,15.379,0.5c3.036-0.013,5.986,1.006,8.368,2.889
                        c1.291,1.009,2.431,2.199,3.384,3.533c0.952-1.334,2.092-2.523,3.384-3.533c2.381-1.884,5.331-2.902,8.367-2.889
                        c4.047-0.028,7.917,1.656,10.654,4.637c2.787,3.124,4.296,7.184,4.225,11.37c0,4.5-1.678,8.627-5.281,12.976
                        c-3.225,3.892-7.856,7.841-13.224,12.411c-1.833,1.563-3.911,3.333-6.066,5.219C28.619,47.611,27.888,47.886,27.131,47.886z" />
                  </svg>
                  <svg class="card-icon share_ic" width="13" height="14" viewBox="0 0 36.902 41.222"
                    (click)="shareSongParent(listArray[i])">
                    <path
                      d="M261.1,443.232a6.535,6.535,0,0,0-4.744,2.047,7.036,7.036,0,0,0-.916,1.193l-11.594-7.327a7.178,7.178,0,0,0,0-5.161l11.6-7.272a6.646,6.646,0,0,0,5.657,3.247,6.993,6.993,0,1,0-6.71-6.988,7.188,7.188,0,0,0,.447,2.488l-11.611,7.283a6.643,6.643,0,0,0-5.61-3.163,6.992,6.992,0,0,0,0,13.973,6.642,6.642,0,0,0,5.609-3.164l11.61,7.338a7.24,7.24,0,0,0-.445,2.494,7.087,7.087,0,0,0,1.965,4.941,6.521,6.521,0,0,0,9.488,0,7.191,7.191,0,0,0,0-9.88A6.534,6.534,0,0,0,261.1,443.232Z"
                      transform="translate(-230.907 -415.984)" fill="#fff"></path>
                  </svg>
                </div>
              </div>
              <div class="card-content">
                <h4 (click)="routeToParent(getRouteUrl(data))">{{getContentTitle(data)}}</h4>
                <span>{{data.artist_name}}</span>
              </div>
            </div>
          </li>
        </ul>



        <!-- <ul *ngIf="!isSquare && listArray.length > 0" #slider (scroll)="onScroll($event)">
          <li *ngFor="let data of listArray;let last = last; let i = index;" class="slider-item">
            <div class="single-card-circle">
              <div class="card-circle-thumb">
                <img [src]="data?.artist_thumbnail" alt="Artist Thumb" />
                <div class="overlay" (click)="routeToParent('/audio/artist-detail/' + data.slug)"></div>
                <div class="hover-border"></div>
                <div class="action-holder">
                  <svg class="card-icon share_ic" width="17" height="18" viewBox="0 0 36.902 41.222"
                    (click)="shareArtistParent(i)">
                    <path
                      d="M261.1,443.232a6.535,6.535,0,0,0-4.744,2.047,7.036,7.036,0,0,0-.916,1.193l-11.594-7.327a7.178,7.178,0,0,0,0-5.161l11.6-7.272a6.646,6.646,0,0,0,5.657,3.247,6.993,6.993,0,1,0-6.71-6.988,7.188,7.188,0,0,0,.447,2.488l-11.611,7.283a6.643,6.643,0,0,0-5.61-3.163,6.992,6.992,0,0,0,0,13.973,6.642,6.642,0,0,0,5.609-3.164l11.61,7.338a7.24,7.24,0,0,0-.445,2.494,7.087,7.087,0,0,0,1.965,4.941,6.521,6.521,0,0,0,9.488,0,7.191,7.191,0,0,0,0-9.88A6.534,6.534,0,0,0,261.1,443.232Z"
                      transform="translate(-230.907 -415.984)" fill="#fff"></path>
                  </svg>
                </div>
              </div>
              <div class="card-content">
                <h4 (click)="routeToParent('/audio/artist-detail/' + data.slug)">{{data.artist_name}}</h4>
              </div>
            </div>
          </li>
        </ul> -->

      </div>
    </div>
  </div>
</section>